module.exports = __webpack_public_path__ + "img/02.72a306f3.jpg";